
import React from 'react';
import AboutCompany from './AboutCompany';
import OurCommitments from './OurCommitments';
import ContactBanner from './ContactBanner';
import OurLeadership from './OurLeadership';
import OurTeam from './OurTeam';
import Ourcabs from './Ourcabs';
const AboutPAGE = () => {
    return (
        <div>
           <ContactBanner/>
           <AboutCompany />
      <OurCommitments />
      <OurLeadership/>
      <Ourcabs/>
      <OurTeam/>
         
        </div>
    );
};

export default AboutPAGE;